import { Component, Host, h, Prop } from '@stencil/core';
import { RcmImageProp } from '../rcm-image/rcm-image.types';
import { StringService } from '../../services';

@Component({
  tag: 'rcm-image-only',
  styleUrl: 'rcm-image-only.scss',
  shadow: true,
})
export class RcmImageOnly {
  @Prop() imageSrc: RcmImageProp | string;

  @Prop() alt: string;

  /** Image caption - overrides any `caption` in the `src` prop if it is an ImageProp */
  @Prop() public caption: string;

  /** Image copyright text - overrides any `copyright` in the `src` prop if it is an ImageProp */
  @Prop() public copyright: string;

  /** Manage if title/ caption should be displayed */
  @Prop() public showCaption = false;

  /** Manage if copyright should be displayed */
  @Prop() public showCopyright = false;

  private get imageAttributes(): RcmImageProp {
    const parsed = StringService.stringToObject(this.imageSrc) as string | RcmImageProp;
    const src = typeof parsed === 'string' ? parsed : (parsed || {}).src;
    const replacedSrc = (src || '').replace(/\/\$0x\$1/g, '');

    return typeof parsed === 'string'
      ? {
          src: replacedSrc,
          caption: this.caption ? this.caption : '',
          copyright: this.copyright,
          alt: this.alt,
        }
      : {
          src: replacedSrc,
          caption: this.caption || parsed?.caption || '',
          copyright: this.copyright || parsed?.copyright,
          alt: this.alt || parsed?.alt,
        };
  }

  render() {
    const { src, caption, copyright, alt } = this.imageAttributes || {};

    return StringService.isValidImageSrc(src) ? (
      <Host>
        <rcm-container rcm-container>
          <rcm-column span={12}>
            <rcm-image alt={alt} src={src}></rcm-image>
            {((this.showCaption && caption) || (this.showCopyright && copyright)) && (
              <div class="description">
                {this.showCaption && caption && <figcaption class="caption">{caption}</figcaption>}
                {this.showCopyright && copyright && <div class="copyright">&copy; {copyright}</div>}
              </div>
            )}
          </rcm-column>
        </rcm-container>
      </Host>
    ) : (
      false
    );
  }
}
